// Documents extension (admin side): the product's datasheets and specifications — uploaded, named, ordered and
// removed here; the product page lists them in its Specifications tab (./storefront.jsx). The API's extension of
// the same id (aldoo-com-api catalog/store/extensions/documents) keeps them; a catalog import may bring them too.
import { DocumentTextIcon } from "@heroicons/react/24/outline"
import DocumentsTab from "./DocumentsTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "documents",
  label: "Documents",
  description: "Datasheets and specification files, listed in the Specifications tab of the product page",
  section: {
    component: catalogSection(DocumentsTab),
    label: "Documents",
    icon: DocumentTextIcon,
    order: 650,
    visible: catalogVisible("documents"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
